<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="untitled-1"></div>
<div class="calibre1" id="untitled-2">
<div class="calibre1"></div>
<div class="calibre1">
<p class="normal-213-0-override1"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-213-0-override1"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-213-0-override1"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-213-0-override1"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-213-0-override1"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-213-0-override1"><span class="no-style-override"><br class="calibre1"/></span></p>
<p class="normal-213-0-override"><span class="no-style-override">Some names have been changed to protect the privacy of some individuals discussed in this book.</span></p>
<p class="calibre2" id="calibre_pb_4"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// disclaimer.vue?3263260c